const searchTypeReducer = (state = {}, action) => {
      switch (action.type) {
            case 'SET_SELECTED_SEARCH_TYPE':
                  return { selectedSearchType: action.selectedSearchType }
            default:
                  return state;
      }
     
};
export default searchTypeReducer;